import Spinner from './Spinner.jsx';

export default function Table({ columns, data, loading = false, empty = 'Sin resultados', onRowClick, rowKey = 'id' }) {
  if (loading) {
    return <div className="card flex items-center justify-center py-10"><Spinner size="lg" /></div>;
  }
  if (!data || data.length === 0) {
    return <div className="card text-center py-10 text-slate-400 text-sm">{empty}</div>;
  }
  return (
    <div className="card p-0 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-bg-elevated">
            <tr>
              {columns.map((col) => (
                <th key={col.key} className="text-left font-medium text-slate-300 px-4 py-3 whitespace-nowrap">
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr
                key={row[rowKey] ?? idx}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={`border-t border-border ${onRowClick ? 'cursor-pointer hover:bg-bg-elevated' : ''}`}
              >
                {columns.map((col) => (
                  <td key={col.key} className="px-4 py-3 text-slate-200 align-middle">
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
